<div class="cv-studio-back">
  <a [routerLink]="parentCvsLink" class="cv-studio-back-link">
    <nb-icon icon="arrow-back-outline"></nb-icon>
    <span>{{ 'cv_studio.back_to_cvs' | translate }}</span>
  </a>
</div>
<article class="cv-studio">
  <bst-cv-studio-rail
    [baseLayouts]="baseLayouts"
    [templates]="templates"
    [selection]="selection"
    [loading]="loading"
    (selectionChange)="select($event)">
  </bst-cv-studio-rail>

  <section class="cv-studio-pane">
    @if (loading) {
      <p class="cv-studio-empty">Loading...</p>
    } @else if (error) {
      <p class="cv-studio-empty cv-studio-error">{{ error }}</p>
    } @else if (!selection && templates.length === 0) {
      <div class="cv-studio-empty cv-studio-empty-hero">
        <nb-icon icon="layout-outline"></nb-icon>
        <h2>{{ 'cv_studio.empty_hero_title' | translate }}</h2>
        <p>{{ 'cv_studio.empty_hero_body' | translate }}</p>
        <button nbButton status="primary" (click)="select({ type: 'upload' })">
          {{ 'cv_studio.empty_hero_cta' | translate }}
        </button>
      </div>
    } @else if (!selection) {
      <div class="cv-studio-empty">
        <nb-icon icon="layout-outline"></nb-icon>
        <p>Select a template or Theme from the left to get started.</p>
      </div>
    } @else if (selection.type === 'builtin') {
      <bst-cv-studio-pane-builtin
        [layout]="selection.layout"
        [clientId]="clientId"
        (useAsBase)="onUseAsBase($event)">
      </bst-cv-studio-pane-builtin>
    } @else if (selection.type === 'custom') {
      <bst-cv-studio-pane-custom
        [template]="selection.template"
        [clientId]="clientId"
        [baseLayouts]="baseLayouts"
        (templateUpdated)="onTemplateUpdated($event)"
        (templateDeleted)="onTemplateDeleted($event)"
        (replaceFiles)="onReplaceFiles($event)">
      </bst-cv-studio-pane-custom>
    } @else if (selection.type === 'theme') {
      <bst-cv-studio-pane-theme [clientId]="clientId"></bst-cv-studio-pane-theme>
    } @else if (selection.type === 'house') {
      <bst-cv-studio-pane-house [clientId]="clientId"></bst-cv-studio-pane-house>
    } @else if (selection.type === 'upload') {
      <bst-cv-studio-pane-upload
        [clientId]="clientId"
        [prefilledLayoutId]="selection.prefilledLayoutId"
        [replaceTemplateId]="selection.replaceTemplateId"
        [replaceTemplateName]="selection.replaceTemplateName"
        (templateCreated)="onTemplateCreated($event)"
        (cancelled)="onUploadCancelled()">
      </bst-cv-studio-pane-upload>
    }
  </section>
</article>
